import Quagga from "@ericblade/quagga2/dist/quagga.js";

let running = false;
let starting = false;
let detectedLocked = false;
let activeContainer = null;
let detectedHandler = null;
let lifecycleToken = 0;

function normalizeVideoElement(video) {
	if (!video) return;
	if (video.getAttribute("src") === "") {
		video.removeAttribute("src");
	}
}

function cleanupContainerPreview() {
	if (!activeContainer) return;

	activeContainer.querySelectorAll("video").forEach((video) => {
		normalizeVideoElement(video);
		const stream = video.srcObject;
		if (stream?.getTracks) {
			stream.getTracks().forEach((track) => track.stop());
		}
		video.srcObject = null;
		video.removeAttribute("src");
	});

	activeContainer.innerHTML = "";
}

function detachDetectedHandler() {
	if (!detectedHandler) return;
	Quagga.offDetected(detectedHandler);
	detectedHandler = null;
}

export function isScannerRunning() {
	return running || starting;
}

export async function startScanner(containerEl, onDetected) {
	if (running || starting) return;
	if (!containerEl) throw new Error("Scanner container bulunamadi.");

	const token = ++lifecycleToken;
	starting = true;
	detectedLocked = false;
	activeContainer = containerEl;
	activeContainer.innerHTML = "";
	activeContainer.classList.add("barcode-scanner-preview--loading");

	try {
		await new Promise((resolve, reject) => {
			Quagga.init(
				{
					inputStream: {
						name: "Live",
						type: "LiveStream",
						target: containerEl,
						constraints: {
							facingMode: "environment",
						},
					},
					decoder: {
						readers: ["code_128_reader"],
					},
					locator: {
						patchSize: "medium",
						halfSample: true,
					},
					numOfWorkers: 0,
					locate: true,
				},
				(err) => {
					if (err) {
						reject(err);
						return;
					}
					resolve();
				},
			);
		});
	} catch (err) {
		if (token === lifecycleToken) {
			starting = false;
			activeContainer = null;
		}
		containerEl.classList.remove("barcode-scanner-preview--loading");
		throw err;
	}

	if (token !== lifecycleToken || !activeContainer) {
		starting = false;
		containerEl.classList.remove("barcode-scanner-preview--loading");
		try {
			Quagga.stop();
		} catch {
			// Stop best-effort.
		}
		return;
	}

	detectedHandler = (result) => {
		const code = String(result?.codeResult?.code ?? "").trim();
		if (!code || detectedLocked) return;
		detectedLocked = true;
		onDetected?.(code);
	};

	Quagga.onDetected(detectedHandler);
	Quagga.start();
	running = true;
	starting = false;
	containerEl.querySelectorAll("video").forEach(normalizeVideoElement);
	containerEl.classList.remove("barcode-scanner-preview--loading");
}

export function stopScanner() {
	lifecycleToken += 1;
	detachDetectedHandler();

	if (running || starting) {
		try {
			Quagga.stop();
		} catch {
			// Preview temizligi asagida ekstra garanti olarak calisiyor.
		}
	}

	try {
		Quagga.CameraAccess?.release?.();
	} catch {
		// Camera release best-effort.
	}

	running = false;
	starting = false;
	detectedLocked = false;
	activeContainer?.classList.remove("barcode-scanner-preview--loading");
	cleanupContainerPreview();
	activeContainer = null;
}
